import Row from "./Row.js";
import Helper from "./Helper.js";
export default class PalletTop {
  constructor(canvas, ctx, pallet, layers) {
    this.offsets = {
      top: 90,
      left: 90,
      bottom: 50,
      right: 50
    };
    this.dragging = false;
    this.canvas = canvas;
    this.ctx = ctx;
    this.initialize(pallet, layers);
    this.onMouseMove = event => {
      this.drag(event);
    };
    this.onMouseUp = () => {
      this.drop();
    };
  }

  initialize(pallet, layers) {
    this.layer1 = layers.layer1;
    this.layer2 = layers.layer2;
    this.layer3 = layers.layer3;
    this.layer4 = layers.layer4;
    // this.pallet = pallet;
    this.pallet = pallet;
    this.rows = Row.getRows(pallet.products);
    this.draw();
  }

  draw() {
    //todo change pallet to rows.getwidth
    this.canvas.width =
      this.pallet.length + this.offsets.left + this.offsets.right;
    this.canvas.height =
      this.pallet.width + this.offsets.top + this.offsets.bottom;
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    //draw base
    this.ctx.fillStyle = "#e9d79f";
    if (this.doesNotFit() && !this.dragging) {
      this.ctx.fillStyle = "red";
    }
    this.ctx.fillRect(
      this.offsets.left,
      this.offsets.top,
      this.pallet.length,
      this.pallet.width
    );
    if (this.layer1) {
      this.pallet.pallet_structure.drawFirstLayer(
        this.ctx,
        this.pallet,
        this.offsets
      );
    }
    if (this.layer2) {
      this.pallet.pallet_structure.drawSecondLayer(
        this.ctx,
        this.pallet,
        this.offsets
      );
    } else {
      this.drawWidth();
    }
    if (this.layer3) {
      this.pallet.pallet_structure.drawThirdLayer(
        this.ctx,
        this.pallet,
        this.offsets
      );
    } else {
      this.drawLength();
    }
    if (this.onProduct) {
      this.drawShadow(this.onProduct);
    } else {
      if (this.betweenProducts) this.drawShadow(this.betweenProducts);
      if (this.movingTo) this.drawShadow(this.movingTo);
    }
    if (this.layer4) {
      this.drawStacks();
    }
  }

  drawShadow({ x, y, width, height, color }) {
    if (color) {
      this.ctx.fillStyle = color;
    } else {
      this.ctx.fillStyle = "rgb(0, 0, 0, 0.5)";
    }
    this.ctx.fillRect(x, y, width, height);
    this.movingTo = null; // make sure shadow goes away
  }

  /**
   * draw stacks function
   */
  drawStacks() {
    this.rows.forEach(row => {
      row.stacks.forEach(stack => {
        const x = stack.x + this.offsets.left;
        const y = stack.y + this.offsets.top;
        const width = stack.width;
        const height = stack.height;
        this.ctx.fillStyle =
          stack.products[0].status > 12 && stack.products[0].status < 15
            ? "rgb(152, 209, 160)"
            : "#FFFFFF";
        if (
          Math.round(stack.getHeight() + this.pallet.pallet_height) > Math.round(this.pallet.max_height)
        ) {
          this.ctx.fillStyle = "red";
        }
        this.ctx.strokeStyle = "rgb(0,0,0)";
        this.ctx.fillRect(x, y, width, height);
        this.ctx.strokeRect(x, y, width, height);
        this.ctx.font = `${60 / this.pallet.divider}px Arial`;
        this.ctx.fillStyle = "rgb(0,0,0)";
        this.ctx.textAlign = "center";
        this.ctx.textBaseline = "middle";
        this.ctx.fillText(
          stack.toString(this.pallet),
          x + width / 2,
          y + height / 2
        );
      });
    });
  }

  /**
   * start dragging event
   * @param {*} event
   */
  grab(event) {
    this.selectedStack = this.overProduct(event);
    if (this.selectedStack != null) {
      this.mouseOffset = {
        left: event.clientX - this.selectedStack.x,
        top: event.clientY - this.selectedStack.y
      };
      this.mouseMovedHandler = this.onMouseMove.bind(this);
      this.mouseUpHandler = this.onMouseUp.bind(this);
      document.body.addEventListener("mousemove", this.mouseMovedHandler);
      document.body.addEventListener("mouseup", this.mouseUpHandler);
    }
  }

  /**
   * rearenges stacks order on move event
   * @param {*} event
   */
  drag(event) {
    this.dragging = true;
    //moves product according to offset
    this.selectedStack.updateCoordinates(
      event.clientX - this.mouseOffset.left,
      event.clientY - this.mouseOffset.top
    );
    this.betweenProducts = Row.getBetweenRows(
      this.pallet,
      this.rows,
      this.selectedStack,
      this.offsets
    );
    this.onProduct = Row.getOnProduct(
      this.pallet,
      this.rows,
      this.selectedStack,
      this.offsets
    );
    this.movingTo = Row.getMovingTo(
      this.pallet,
      this.rows,
      this.selectedStack,
      this.offsets
    );
    this.draw();
  }

  /**
   * initiated when released
   * if dropped between product, move stacks, otherwise just move
   * save changes
   * dispatch move event on finish
   */
  async drop() {
    this.dragging = false;
    if (this.onProduct) {
      this.rows = this.pallet.moveOnProduct(this.rows, this.selectedStack, this.onProduct.stack);
      this.onProduct = null;
    } else {
      if (this.betweenProducts) {
        this.rows = this.pallet.moveBetween(
          this.rows,
          this.selectedStack,
          this.betweenProducts,
          this.offsets
        );
        this.betweenProducts = null;
      } else {
        //twice in case length doesn't pick up
        this.rows = this.pallet.move(this.rows);
      }
    }

    this.rows = this.pallet.move(this.rows);
    // twice for correction
    document.body.removeEventListener("mousemove", this.mouseMovedHandler);
    document.body.removeEventListener("mouseup", this.mouseUpHandler);
    await this.pallet.saveChanges(this.rows);
    document.dispatchEvent(new Event("moved"));
  }

  /**
   * returns product on which we clicked or null
   * @param {*} event - mouse event
   * @return {Product} hovering product
   *
   */
  overProduct(event) {
    if (!this.layer4) return null;
    const mousePos = {
      x: event.offsetX,
      y: event.offsetY
    };

    let hoveringStack = null;
    this.rows.forEach(row => {
      row.stacks.forEach(stack => {
        if (
          mousePos.x > stack.x + this.offsets.left &&
          mousePos.x < stack.x + stack.width + this.offsets.left &&
          mousePos.y > stack.y + this.offsets.top &&
          mousePos.y < stack.y + stack.height + this.offsets.top
        ) {
          hoveringStack = stack;
        }
      });
    });
    return hoveringStack;
  }

  async stackOnTop(selectedStack) {
    this.rows = this.pallet.moveOnTop(this.rows, selectedStack);
    this.drop();
  }

  moveDown(selectedStack) {
    this.rows = this.pallet.moveDown(this.rows, selectedStack);
    this.drop();
  }

  doesNotFit() {
    if (!this.pallet) {
      return false;
    }
    if (this.pallet) {
      if (this.pallet.products.length < 1) {
        return false;
      }
    }
    if (this.pallet.temporary) {
      return false;
    }
    if (
      Math.round(this.pallet.getWeight()) > Math.round(this.pallet.max_weight)
    ) {
      return true;
    }
    if (!this.pallet.productsFit()) {
      return true;
    }
    return false;
  }

  openDialogMenu(event) {
    if (this.pallet.truck_id != null) return;
    const mousePos = {
      x: event.offsetX,
      y: event.offsetY
    };
    if (this.layer1) {
      if (
        mousePos.x > this.offsets.left &&
        mousePos.x < this.offsets.left + this.pallet.length &&
        mousePos.y > this.offsets.top + this.pallet.width
      ) {
        document.dispatchEvent(new CustomEvent("layerEdit", { detail: 1 }));
      }
    }
    if (
      mousePos.x < this.offsets.left &&
      this.offsets.top < mousePos.y &&
      mousePos.y < this.offsets.top + this.pallet.width
    ) {
      if (mousePos.x < this.offsets.left / 2) {
        document.dispatchEvent(
          new CustomEvent("palletEdit", { detail: "width" })
        );
      } else {
        if (this.layer2) {
          document.dispatchEvent(new CustomEvent("layerEdit", { detail: 2 }));
        }
      }
    }
    if (
      mousePos.x > this.offsets.left &&
      mousePos.x < this.offsets.left + this.pallet.length &&
      mousePos.y < this.offsets.top
    ) {
      if (mousePos.y < this.offsets.top / 2) {
        document.dispatchEvent(
          new CustomEvent("palletEdit", { detail: "length" })
        );
      } else {
        if (this.layer3) {
          document.dispatchEvent(new CustomEvent("layerEdit", { detail: 3 }));
        }
      }
    }
  }

  drawLength() {
    this.ctx.strokeStyle = "black";
    Helper.canvasArrow(
      this.ctx,
      this.offsets.left,
      this.offsets.top - 40,
      this.canvas.width - this.offsets.right,
      this.offsets.top - 40
    );
    Helper.canvasArrow(
      this.ctx,
      this.canvas.width - this.offsets.right,
      this.offsets.top - 40,
      this.offsets.left,
      this.offsets.top - 40
    );
    this.ctx.textAlign = "center";
    this.ctx.font = "10px Arial";
    this.ctx.fillStyle = "black";
    this.ctx.fillText(
      Math.round(this.pallet.length * this.pallet.divider),
      (2 * this.offsets.left + this.pallet.length) / 2,
      this.offsets.top - 50
    );
  }

  drawWidth() {
    this.ctx.strokeStyle = "black";
    Helper.canvasArrow(
      this.ctx,
      this.offsets.left - 50,
      this.offsets.top,
      this.offsets.left - 50,
      this.canvas.height - this.offsets.bottom
    );
    Helper.canvasArrow(
      this.ctx,
      this.offsets.left - 50,
      this.canvas.height - this.offsets.bottom,
      this.offsets.left - 50,
      this.offsets.top
    );
    this.ctx.textAlign = "center";
    this.ctx.font = "10px Arial";
    this.ctx.fillStyle = "black";
    this.pallet.pallet_structure.drawVerticalText(
      this.ctx,
      Math.round(this.pallet.width * this.pallet.divider),
      this.offsets.left - 60,
      (2 * this.offsets.top + this.pallet.width) / 2,
      -1
    );
  }

  upperRow(selectedStack) {
    let rowIndex = 0;
    let stackIndex = 0;
    this.rows.forEach((row, i) => {
      row.stacks.forEach((stack, j) => {
        if (stack.products[0].id == selectedStack.products[0].id) {
          rowIndex = i;
          stackIndex = j;
        }
      });
    });
    if (!rowIndex) {
      return;
    } // if not found or first row return
    this.rows[rowIndex].stacks.splice(stackIndex, 1);
    if (this.rows[rowIndex].stacks.length == 0) {
      this.rows.splice(rowIndex, 1);
    }
    selectedStack.updateCoordinates(
      this.pallet.spacing_ends + this.rows[rowIndex - 1].getWidth(),
      this.rows[rowIndex - 1].getTop()
    );
    this.rows[rowIndex - 1].stacks.push(selectedStack);
  }
}
